import type { HttpTypes } from "@medusajs/types"
import type { RouteObject, UIMatch } from "react-router-dom"
import { ErrorBoundary } from "../../components/utilities/error-boundary"
import { t } from "i18next"
export const RoutesSkinCare: RouteObject[] = [
  {
    path: "/accounts",
    errorElement: <ErrorBoundary />,
    handle: {
      breadcrumb: () => "Accounts",
    },
    children: [
      {
        path: "",
        lazy: () => import("../../routes/ww-accounts/account-list"),
        children: [
          {
            path: "create",
            lazy: () => import("../../routes/ww-accounts/account-create"),
          },
          {
            path: "create-patient",
            lazy: () =>
              import("../../routes/ww-accounts/account-patient-create"),
          },
        ],
      },
      {
        path: ":id",
        lazy: async () => {
          const { Component } =
            await import("../../routes/ww-accounts/account-detail")

          return {
            Component,
          }
        },
        children: [
          {
            path: "edit",
            lazy: () => import("../../routes/ww-accounts/account-edit"),
          },

          {
            path: ":order_id/transfer",
            lazy: () => import("../../routes/orders/order-request-transfer"),
          },
        ],
      },
    ],
  },

  {
    path: "/patients",
    errorElement: <ErrorBoundary />,
    handle: {
      breadcrumb: () => "Patients",
    },
    children: [
      {
        path: "",
        lazy: () => import("../../routes/ww-patients/patient-list"),
      },
      {
        path: ":id",
        lazy: async () => {
          const { Component } =
            await import("../../routes/ww-patients/patient-detail")

          return {
            Component,

            // handle: {
            //   breadcrumb: (match: UIMatch<HttpTypes.AdminCustomerResponse>) => (
            //     <Breadcrumb {...match} />
            //   ),
            // },
          }
        },
      },
    ],
  },

  {
    path: "/plato-patients",
    errorElement: <ErrorBoundary />,
    handle: {
      breadcrumb: () => "Plato Patients",
    },
    children: [
      {
        path: "",
        lazy: () => import("../../routes/ww-plato-patients/patient-list"),
        //   children: [
        //     {
        //       path: "create",
        //       lazy: () => import("../../routes/ww-plato-patients/patient-create"),
        //     },
        //   ],
      },
      {
        path: ":id",
        lazy: async () => {
          const { Component } =
            await import("../../routes/ww-plato-patients/patient-detail")

          return {
            Component,

            // handle: {
            //   breadcrumb: (match: UIMatch<HttpTypes.AdminCustomerResponse>) => (
            //     <Breadcrumb {...match} />
            //   ),
            // },
          }
        },
        // children: [
        //   {
        //     path: "edit",
        //     lazy: () => import("../../routes/ww-plato-patients/patient-edit"),
        //   },

        //   {
        //     path: ":order_id/transfer",
        //     lazy: () => import("../../routes/orders/order-request-transfer"),
        //   },
        // ],
      },
    ],
  },

  {
    path: "/pending-orders",
    errorElement: <ErrorBoundary />,
    handle: {
      breadcrumb: () => "Pending Orders",
    },
    children: [
      {
        path: "",
        lazy: () => import("../../routes/ww-pending-orders/order-list"),
      },
      {
        path: ":id",
        lazy: async () => {
          const { Component, Breadcrumb, loader } =
            await import("../../routes/ww-pending-orders/order-detail")

          return {
            Component,
            loader,
            handle: {
              breadcrumb: (match: UIMatch<HttpTypes.AdminOrderResponse>) => (
                <Breadcrumb {...match} />
              ),
            },
          }
        },
        children: [
          {
            path: "fulfillment",
            lazy: () =>
              import("../../routes/ww-pending-orders/order-create-fulfillment"),
          },
          {
            path: "returns/:return_id/receive",
            lazy: () =>
              import("../../routes/ww-pending-orders/order-receive-return"),
          },
          {
            path: "allocate-items",
            lazy: () =>
              import("../../routes/ww-pending-orders/order-allocate-items"),
          },
          {
            path: ":f_id/create-shipment",
            lazy: () =>
              import("../../routes/ww-pending-orders/order-create-shipment"),
          },
          {
            path: "returns",
            lazy: () =>
              import("../../routes/ww-pending-orders/order-create-return"),
          },
          {
            path: "claims",
            lazy: () =>
              import("../../routes/ww-pending-orders/order-create-claim"),
          },
          {
            path: "exchanges",
            lazy: () =>
              import("../../routes/ww-pending-orders/order-create-exchange"),
          },
          {
            path: "edits",
            lazy: () =>
              import("../../routes/ww-pending-orders/order-create-edit"),
          },
          {
            path: "refund",
            lazy: () =>
              import("../../routes/ww-pending-orders/order-create-refund"),
          },
          {
            path: "transfer",
            lazy: () =>
              import("../../routes/ww-pending-orders/order-request-transfer"),
          },
          {
            path: "email",
            lazy: () =>
              import("../../routes/ww-pending-orders/order-edit-email"),
          },
          {
            path: "shipping-address",
            lazy: () =>
              import("../../routes/ww-pending-orders/order-edit-shipping-address"),
          },
          {
            path: "billing-address",
            lazy: () =>
              import("../../routes/ww-pending-orders/order-edit-billing-address"),
          },
          {
            path: "metadata/edit",
            lazy: () => import("../../routes/ww-pending-orders/order-metadata"),
          },
        ],
      },
    ],
  },

  {
    path: "/plato-inventory",
    errorElement: <ErrorBoundary />,
    handle: {
      breadcrumb: () => "Plato Inventory",
    },
    children: [
      {
        path: "",
        lazy: () => import("../../routes/ww-plato-inventory/inventory-list"),
        // children: [
        //   {
        //     path: "create",
        //     lazy: () =>
        //       import("../../routes/ww-plato-inventory/inventory-create"),
        //   },
        //   {
        //     path: "stock",
        //     lazy: () =>
        //       import("../../routes/ww-plato-inventory/inventory-stock"),
        //   },
        // ],
      },
      {
        path: ":id",
        lazy: async () => {
          const { Component } =
            await import("../../routes/ww-plato-inventory/inventory-detail")

          return {
            Component,
            // loader,
            // handle: {
            //   breadcrumb: (
            //     match: UIMatch<HttpTypes.AdminInventoryItemResponse>
            //   ) => <Breadcrumb {...match} />,
            // },
          }
        },
        // children: [
        //   {
        //     path: "edit",
        //     lazy: () =>
        //       import(
        //         "../../routes/ww-plato-inventory/inventory-detail/components/edit-inventory-item"
        //       ),
        //   },
        // {
        //   path: "attributes",
        //   lazy: () =>
        //     import(
        //       "../../routes/ww-plato-inventory/inventory-detail/components/edit-inventory-item-attributes"
        //     ),
        // },
        // {
        //   path: "metadata/edit",
        //   lazy: () =>
        //     import("../../routes/ww-plato-inventory/inventory-metadata"),
        // },
        // {
        //   path: "locations",
        //   lazy: () =>
        //     import(
        //       "../../routes/ww-plato-inventory/inventory-detail/components/manage-locations"
        //     ),
        // },
        // {
        //   path: "locations/:location_id",
        //   lazy: () =>
        //     import(
        //       "../../routes/ww-plato-inventory/inventory-detail/components/adjust-inventory"
        //     ),
        // },
        // ],
      },
    ],
  },

  {
    path: "/lalamove-balance",
    errorElement: <ErrorBoundary />,
    handle: {
      breadcrumb: () => "Balance",
    },
    children: [
      {
        path: "",
        lazy: () => import("../../routes/ww-lalamove-balance/balance-list"),
      },
      // {
      //   path: ":id",
      //   lazy: async () => {
      //     const { Component } =
      //       await import("../../routes/ww-lalamove-balance/balance-detail")

      //     return {
      //       Component,
      //     }
      //   },
      // },
    ],
  },

  {
    path: "/lalamove-shipping-fee",
    errorElement: <ErrorBoundary />,
    handle: {
      breadcrumb: () => "Shipping Fee Report",
    },
    children: [
      {
        path: "",
        lazy: () => import("../../routes/ww-lalamove-shipping-fee/shipping-fee-list"),
      },
      // {
      //   path: ":id",
      //   lazy: async () => {
      //     const { Component } =
      //       await import("../../routes/ww-lalamove-balance/balance-detail")

      //     return {
      //       Component,
      //     }
      //   },
      // },
    ],
  },

  {
    path: "/inventory",
    errorElement: <ErrorBoundary />,
    handle: {
      breadcrumb: () => t("inventory.domain"),
    },
    children: [
      {
        path: "",
        lazy: () => import("../../routes/ww-inventory/inventory-list"),
        children: [
          {
            path: "create",
            lazy: () => import("../../routes/ww-inventory/inventory-create"),
          },
          {
            path: "stock",
            lazy: () => import("../../routes/ww-inventory/inventory-stock"),
          },
        ],
      },
      {
        path: ":id",
        lazy: async () => {
          const { Component, Breadcrumb, loader } =
            await import("../../routes/ww-inventory/inventory-detail")

          return {
            Component,
            loader,
            handle: {
              breadcrumb: (
                match: UIMatch<HttpTypes.AdminInventoryItemResponse>
              ) => <Breadcrumb {...match} />,
            },
          }
        },
        children: [
          {
            path: "edit",
            lazy: () =>
              import("../../routes/ww-inventory/inventory-detail/components/edit-inventory-item"),
          },
          {
            path: "attributes",
            lazy: () =>
              import("../../routes/ww-inventory/inventory-detail/components/edit-inventory-item-attributes"),
          },
          {
            path: "metadata/edit",
            lazy: () => import("../../routes/ww-inventory/inventory-metadata"),
          },
          {
            path: "locations",
            lazy: () =>
              import("../../routes/ww-inventory/inventory-detail/components/manage-locations"),
          },
          {
            path: "locations/:location_id",
            lazy: () =>
              import("../../routes/ww-inventory/inventory-detail/components/adjust-inventory"),
          },
        ],
      },
    ],
  },

  {
    path: "/plato-invoice",
    errorElement: <ErrorBoundary />,
    handle: {
      breadcrumb: () => "Invoice",
    },
    children: [
      {
        path: "",
        lazy: () => import("../../routes/ww-plato-invoice/invoice-list"),
      },
      {
        path: ":id",
        lazy: async () => {
          const { Component } =
            await import("../../routes/ww-plato-invoice/invoice-detail")

          return {
            Component,
          }
        },
      },
    ],
  },
]
